/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_portada.mp4'
import img_fondo from '../../../Recursos/img_fondo.png'
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const navigate = useNavigate();
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <video width={'100%'} height={ sCell ? 480 : 640}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       //   backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted poster={img_fondo}>

                <source src={fondo} type="video/mp4"/>

            </video>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    marginTop: sCell ? -60 : -82,
                    zIndex: 2,
                    background: `linear-gradient(183deg, #000 2.27%, rgba(0, 0, 0, 0.00) 25.23%, rgba(0, 0, 0, 0.00) 69.32%, #000 97.79%)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: sCell ? 480 : 656
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', maxWidth: '1400px', px: 3}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{py: sCell ? 3 : 8}}
                    >

                        <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Button
                                onClick={() => navigate('/Locales')}
                            >Ver Locales</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 400, color: '#fff'}}>
                                Reconocida por nuestras empanadas irresistibles, preparadas con sabor y amor. Visítanos
                                y
                                descubre por qué nuestros clientes siempre regresan.
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Portada    